import {
  CREATE_SUPPLIER,
  DEACTIVE_SUPPLIER,
  EDIT_SUPPLIER,
  GET_SUPPLIER,
  GET_SUPPLIERS,
  REACTIVE_SUPPLIER,
  USER_LOGO
} from './ApiConstants';
import api from './ApiHandler';

export interface CreateSupplierPayloads {
  name: string;
  entityType: string;
  clientAppName: Array<string>;
  primaryDetails: {
    name: string;
    email: string;
    phone: any;
    password: string;
    address: {
      address1: string;
      zipCode: string;
    };
    description: string;
    recipeBuilder?: boolean;
  };
}

interface SupplierEditPayloads {
  name: string;
  entityType: string;
  clientAppName: Array<string>;
  primaryDetails: {
    id?: any;
    userId?: any;
    name: string;
    email: string;
    phone: number;
    password: string;
    address: {
      address1: string;
      zipCode: string;
    };
    description: string;
    recipeBuilder: boolean;
  };
}

export const getSuppliersByPage = async (payload: any) => {
  return await api.get(GET_SUPPLIERS, { params: payload });
};

export const getSupplier = async (payload: any) => {
  let response = await api.get(GET_SUPPLIER, { params: payload });
  return response;
};

export const createSupplier = async (payload: any) => {
  return await api.post(CREATE_SUPPLIER, { ...payload });
};

export const editSupplier = async (payload: SupplierEditPayloads) => {
  return await api.post(EDIT_SUPPLIER, { ...payload });
};

export const reactiveSupplier = async (payload: any) => {
  return await api.put(REACTIVE_SUPPLIER, { ...payload });
};

export const deactiveSupplier = async (payload: any) => {
  return await api.put(DEACTIVE_SUPPLIER, { ...payload });
};

export const uploadFile = async (file: File, type: string) => {
  if (!file) {
    throw new Error('No file provided for upload.');
  }

  const formData = new FormData();
  formData.append('file', file);
  formData.append('type', type);

  let res = await api.post(USER_LOGO, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return res;
};
